// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"e81c5aa5","35":"9b878a6c"}[chunkId] + ".chunk.js";
};